import { render, staticRenderFns } from "./FormRenderer.vue?vue&type=template&id=dfddf288&scoped=true"
import script from "./FormRenderer.vue?vue&type=script&lang=js"
export * from "./FormRenderer.vue?vue&type=script&lang=js"
import style0 from "./FormRenderer.vue?vue&type=style&index=0&id=dfddf288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfddf288",
  null
  
)

export default component.exports